export interface BlockPosition {
  id: string;
  top: number;
  bottom: number;
}

export function pickNearestBlockId(
  positions: BlockPosition[],
  anchor: number
): string | null {
  if (!positions.length) return null;
  const containing = positions.find(
    (position) => position.top <= anchor && position.bottom >= anchor
  );
  if (containing) return containing.id;

  return positions.reduce((nearest, position) => {
    const positionDistance = Math.min(
      Math.abs(position.top - anchor),
      Math.abs(position.bottom - anchor)
    );
    const nearestDistance = Math.min(
      Math.abs(nearest.top - anchor),
      Math.abs(nearest.bottom - anchor)
    );
    return positionDistance < nearestDistance ? position : nearest;
  }).id;
}
